<template>
  <div class="following">
    <div
      v-if="following.length"
      class="card"
    >
      <user-basic
        v-for="(user, index) in following"
        :key="user.id"
        :user="user"
        :last="index === following.length - 1"
      />
    </div>
  </div>
</template>

<script>
import UserBasic from '@/components/UserBasic.vue';

export default {
  name: 'Following',
  components: {
    UserBasic,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      following: [],
    };
  },
  watch: {
    id() {
      this.fetchFollowing();
    },
  },
  created() {
    this.fetchFollowing();
  },
  methods: {
    async fetchFollowing() {
      const responseData = await this.api({
        url: `users/${this.id}/following`,
        method: 'GET',
      });

      if (responseData.status === 200) {
        this.following = responseData.body;
      }
    },
  },
};
</script>
